const env = process.env.NODE_ENV as string;

const baseUrl: { [key: string]: string } = {
  '': 'http://localhost:4000',
  local: 'http://localhost:4000',
  develop: 'https://api.sourcing-dev.tx.group/outputs',
  production: 'https://api.sourcing.tx.group/outputs'
};

export const BASE_URL = baseUrl[env];

export const REFRESH_INTERVAL = 60000;

export const TAGESANZEIGER = 'www.tagesanzeiger.ch';

export const MIN20 = 'www.20min.ch';

export const HOST_FONTS = {
  'www.tagesanzeiger.ch': '"IBM Plex Sans", Helvetica, Arial, Verdana, sans-serif',
  'www.20min.ch': '"Baton Turbo", sans-serif'
};

export const WIDGET_WIDTH = 668;

export const TEASER_WIDGET_WIDTH = 1679;

export const DEFAULT_TENANT = 'tagesanzeiger';

export const WIDGET_COMPETITIONS_IDS = ['115', '18', '2258', '12', '111', '71', '91', '97'];
